module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"subscriptionManageMenu.editSpendLimit":"Set Spend Limit","subscriptionManageMenu.editName":"Edit Name"}}')
  delete Component.options._Ctor
}
